import API from "shared/services/Api";
import { IAnamneseData, IAnamneseResponse } from "shared/types/Anamnese";

export const postAnamnese = async (
  data: IAnamneseData
): Promise<IAnamneseResponse> => API.post(`oc/anamnesis`, data);
